import { module } from 'modujs'
import VueProductForm from '../vue/components/VueProductForm'
import VueProductRadioSelector from '../vue/components/VueProductRadioSelector'
import VueProductFormSelector from '../vue/components/VueProductFormSelector'
import VueCapitalizeFilter from '../vue/filters/VueCapitalizeFilter'

export default class extends module {
    constructor(m) {
        super(m)

        // UI
        this.$el = this.el
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        // Init vue
        this.initVue()
    }

    destroy() {
        super.destroy()
        this.app?.$destroy?.()
    }

    /////////////////////////
    // Vue Instance
    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this

        /////////////////////////
        // Settings
        Vue.config.devtools = true

        /////////////////////////
        // Vue Filters
        VueCapitalizeFilter()

        /////////////////////////
        // Vue Components
        VueProductForm(moduleInstance)
        VueProductFormSelector()
        VueProductRadioSelector()

        if (!window.commonVueInstancesReady) {
            window.commonVueInstancesReady = true
        }

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el
        })
    }
}
